"use strict";
var BlockedProviderHelper = (function () {
    function BlockedProviderHelper() {
    }
    BlockedProviderHelper.showEventLink = function (baseUrl) {
        return baseUrl === BlockedProviderHelper.emitEventOverrideUrl;
    };
    BlockedProviderHelper.showHrefLink = function (baseUrl) {
        return Boolean(BlockedProviderHelper.getBlockedProviderUrl(baseUrl) && !BlockedProviderHelper.showEventLink(baseUrl));
    };
    BlockedProviderHelper.getBlockedProviderUrl = function (baseUrl) {
        var url = '';
        if (baseUrl) {
            url = baseUrl + '/a/blocklists';
        }
        return url;
    };
    return BlockedProviderHelper;
}());
BlockedProviderHelper.emitEventOverrideUrl = '[emitEvent]';
exports.BlockedProviderHelper = BlockedProviderHelper;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/blocked-provider.helper.js